class HomeFunSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.js-home-fun-swiper', {
      speed: 10000,
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          speed: 10000,
          slidesPerView: 2.5,
          spaceBetween: 20,
        }
      },
    })
    const textSwiper = new Swiper('.js-home-fun-text-swiper', {
      speed: 15000,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        }
      },
    })
  }
}
